export var hasProviderAnyLoanFinished = function (provider, data) {
    if (!data)
        return false;
    return Boolean(data.loans.length > 0 &&
        data.loans.find(function (item) { return item.stage === 5 && item.provider === provider; }));
};
